'use client';
import { FormControl } from 'react-bootstrap';
import { useSearchParams, usePathname, useRouter } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';
import classes from './FilterComps.module.css';
import { Search, ChevronDown } from 'react-feather';

const BrandFilter = (props) => {
	const { theBrand, uniqueBrandList, clearHandler } = props;
	const router = useRouter();
	const params = useSearchParams();
	const pathname = usePathname();

	const brandParam = params.brand;

	const ref = useRef();

	const [showBrands, setShowBrands] = useState();

	useEffect(() => {
		setShowBrands(window.innerWidth > 600 || theBrand ? true : false);
	}, [theBrand]);

	const [searchTerm, setSearchTerm] = useState('');
	const [brandList, setBrandList] = useState([]);

	const onChange = () => {
		setSearchTerm(ref.current.value);
	};

	const [brands, setBrands] = useState([]);

	const countBrands = (brandArray) => {
		const brandCount = {};
		for (let brandObj of brandArray) {
			const normalizedBrand = brandObj.name;
			if (!brandCount[normalizedBrand]) {
				brandCount[normalizedBrand] = {
					name: brandObj.name?.trim(),
					id: brandObj.name
						?.replace(/ /g, '-')
						.replace(/&/g, 'and')
						.toLowerCase(),
					count: brandObj.count,
				};
			}
		}
		let brandCountsArray = Object.values(brandCount);
		return brandCountsArray.sort((a, b) => b.count - a.count);
	};

	useEffect(() => {
		if (uniqueBrandList?.length > 0) {
			const countedBrands = countBrands(uniqueBrandList);
			setBrands(countedBrands);
		} else {
			setBrands([]);
		}
	}, [uniqueBrandList]);

	useEffect(() => {
		const filteredList = brands.filter((brand) => {
			const brandName = brand.name?.toLowerCase()?.trim();
			return brandName?.includes(searchTerm.toLowerCase()?.trim());
		});
		if (filteredList.length > 0) {
			setBrandList(filteredList.map((brand) => brand));
		}
	}, [searchTerm, brands]);

	const showBrandsHandler = () => {
		setShowBrands(!showBrands);
	};

	const brandsHandler = (brand) => {
		let newParams = new URLSearchParams(window.location.search);

		if (!brandParam && brand && window.location.pathname !== '/brand') {
			if (brand) {
				newParams.set('brand', brand.id);
			} else {
				newParams.delete('brand');
			}

			router.push(pathname + '?' + newParams.toString());
		} else if ((brandParam && brand) || window.location.pathname === '/brand') {
			router.push(`/brand/${brand.id}`);
		}

		setSearchTerm('');
	};

	const clearBrandsHandler = (e, brand) => {
		if (!brandParam && brand) {
			clearHandler(e, 'setBrand', 'brand');
		} else {
			router.push(`/collections`);
		}
	};

	const fixEncoding = (str) => {
		return str
			.replace(/Ã¸/g, 'ø')
			.replace(/Ã/g, 'Ó')
			.replace(/Ã¦/g, 'æ')
			.replace(/Ã¥/g, 'å')
			.replace(/Ã¶/g, 'ö')
			.replace(/Ã¸/g, 'ø')
			.replace(/Ã/g, 'Ó')
			.replace(/Ã¦/g, 'æ')
			.replace(/Ã¥/g, 'å');
	};
	return (
		<>
			{brandList?.length > 0 && (
				<div className={classes.desktop}>
					<div className={classes.dropDown}>
						<div onClick={showBrandsHandler} className={classes.justifyBetween}>
							Brands{' '}
							<ChevronDown
								className={showBrands ? classes.flip : classes.icon}
								size={13}
							/>
						</div>
						{showBrands && (
							<>
								<div className={classes.searchBrands}>
									<Search className={classes.lenseIcon} size={12} />
									<FormControl
										className={`${classes.searchBar}`}
										ref={ref}
										type="text"
										placeholder={`Search`}
										onChange={onChange}
										value={searchTerm}
									/>
								</div>
								<div className={classes.desktopBrands}>
									{brandList
										.filter((brand) => brand.count > 0)
										.filter((brand) => brand.name !== '')
										.sort((a, b) => {
											if (a.id === theBrand) return -1;
											if (b.id === theBrand) return 1;
											return 0;
										})
										.map((brand, idx) => (
											<div
												className={
													theBrand === brand.id
														? classes.active
														: classes.selection
												}
												key={idx}
												onClick={
													theBrand === brand.id
														? (e) => clearBrandsHandler(e, brand)
														: () => brandsHandler(brand)
												}
											>
												<h3 className={classes.underline}>
													{fixEncoding(brand.name)}
												</h3>{' '}
												<span className={classes.count}>({brand.count})</span>
											</div>
										))}
								</div>
							</>
						)}
					</div>
				</div>
			)}
		</>
	);
};

export default BrandFilter;
